module.exports = __webpack_public_path__ + "static/media/STPProjectPrevieww935@1x.13f2a29e.jpg";